import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WhatsappTemplatesService {
  private _whatsappTemplatesUrl = `${environment.whatsapp}`;

  constructor(
    private _http: HttpClient
  ) { }

  // whatsapp-templates.service.ts

  // Create WhatsApp Template
  createWhatsappTemplate(formData: any): Observable<any> {
    return this._http.post<any>(`${this._whatsappTemplatesUrl}/template`, formData);
  }

  // Get All WhatsApp Templates
  getWhatsappTemplates(pageNo: any, pageSize: any, searchKeyword: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 10,
      search: searchKeyword || "",
      filters: filters
    };
    return this._http.post<any>(`${this._whatsappTemplatesUrl}/templates`, paginationSettings);
  }
  // Get WhatsApp Template by ID
  getWhatsappTemplateById(templateId: string): Observable<any> {
    return this._http.get<any>(`${this._whatsappTemplatesUrl}/template/${templateId}`);
  }
  // Delete WhatsApp Template
  deleteWhatsappTemplate(templateId: string): Observable<any> {
    return this._http.delete<any>(`${this._whatsappTemplatesUrl}/template/${templateId}`);
  }

}
